import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { ApiService } from '../../../../core/services/api.service';
import { ToastNotifService } from '../../../../core/services/toast-notif.service';
import { Subscription } from 'rxjs';
import { forkJoin } from 'rxjs';
import * as XLSX from 'xlsx';
import {
  MemberLineResponse,
  RegisterMemberPayload,
  licenseInsertList,
  licenseList,
  CarList,
} from '../../../../core/models/member.model';
import {
  InforProviders,
  Providers,
  VehicleDetail,
  InformationResponse,
  Province,
  Color,
  FeeType,
  StatusAPIResponse,
  Blank,
  TaxpayerInfo,
} from '../../../../core/models/information.model';
import {
  FeeDetailsResponse,
  ObjectFeeResponse,
} from '../../../../core/models/parking.model';
import {
  MyVehicleAllResponse,
  MyAddressAllResponse,
  UserVehicleResponse,
  MyMemberCard,
  InsertLicensePayload,
  InsertLicenseResponse,
} from '../../../../core/models/user.model';
import { ToastService } from 'angular-toastify';
import { ApiFormService } from '../../../../core/services/api-form.service';

@Component({
  selector: 'app-register-member',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './register-member.component.html',
  styleUrls: ['./register-member.component.css'],
})
export class RegisterMemberComponent {
  renew_: boolean = false;
  search = '';
  page = 1;
  user_id: number = 0;
  user_name: string = '';
  CardCode: string = '';
  pageSizeOptions = [20, 50, 100];
  pageSize = 20;
  expire_date: string = '';
  allMembers: MemberLineResponse[] = [];
  selectVehicleType: string = '';
  allProviders: Providers[] = [];
  allMemberCard: MyMemberCard[] = [];
  selectMemberCard_: MyMemberCard | null = null;
  selectMember: MemberLineResponse | null = null;
  modalRegister: boolean = false;
  modalSelectProvider: boolean = false;
  modalSelectMemberCard: boolean = false;
  searchProvider: string = '';
  searchMemberCard: string = '';
  disabled: boolean = true;
  remarks: string = '';
  LocationOptions: { id: string; name: string }[] = [];
  selectedLocation: string = '';
  providerId: number = 0;
  providerName: string = '';
  cardMemberName: string = '';
  startDate: Date | null = null;
  today: string = '';
  minStartDate: string = '';
  isLoading: boolean = false;
  CarOptions: { value: string; label: string }[] = [];
  CardOptions: {
    value: number;
    label: string;
    fig_day: number;
    vehicle_type_name: string;
    subscription_id: number;
  }[] = [];
  selectedOption: number | null = null;
  selectedCar: string | null = null;
  selectedBrand: string | null = null;
  selectedFeeType: number | null = null;
  selectedAccountId: number | null = null;
  selectEngine: string | null = null;
  selectedModel: string | null = null;
  selectedColor: string | null = null;
  subscription_id: number | null = null;
  fullFeeList: FeeDetailsResponse[] = []; // เก็บไว้กรองซ้ำได้
  carFilteredPlateList: MyVehicleAllResponse[] = [];
  FeeTypeOptions: { value: number; label: string; status: boolean }[] = [];
  showBank: boolean = false;
  BankOptions: { value: number; label: string }[] = [];
  vehicleDetails: VehicleDetail[] = [];
  BrandOptions: { value: string; label: string }[] = [];
  ModelOptions: { value: string; label: string }[] = [];
  ColorOptions: { value: string; label: string }[] = [];
  ProvinceOptions: { value: string; label: string }[] = [];
  selectedProvince: any = null;
  customer_name: string = '';
  fig_day: number | null = null;
  fee: number | null = null;
  phoneNo: string = '';
  error: string = '';
  modalSelectVehicle: boolean = false;
  license: string = '';
  selectedLicense: string = '';
  licenseAll: MyVehicleAllResponse[] = [];
  carPlateList: MyVehicleAllResponse[] = [];
  // Vehicle Plate
  selectCarPlate: MyVehicleAllResponse[] = [];
  isOpen: boolean = false;
  searchTerm: string = ''; // คำค้นหา
  isRequestTax: boolean = false;
  showTaxModal: boolean = false;
  selectedTaxType: string = '1';
  filteredAddressList: MyAddressAllResponse[] = [];
  selectedAddress: MyAddressAllResponse | null = null;
  addressListAll: MyAddressAllResponse[] = [];
  address_id: number = 0;
  showSelectAddress: boolean = false;
  mainOffice: boolean = false;
  taxName: string = '';
  taxId: string = '';
  address: string = '';
  province_name: string | null = null;
  amphure_name: string | null = null;
  tambon_name: string | null = null;
  email: string = '';
  tax_phone: string = '';
  branchName: string = '';
  branchNo: string = '';
  provincess: any[] = [];
  selectedProvinceId: number | null = null;
  filteredAmphures: any[] = [];
  amphures: any[] = [];
  selectedAmphureId: number | null = null;
  filteredTambons: any[] = [];
  tambons: any[] = [];
  selectedTambonId: number | null = null;
  zipcode: string = '';
  showAddressModal: boolean = false;
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  vehicleId: number = 0;
  base64String: string = '';
  licenseTxt: string = '';
  brandTxt: string = '';
  modelTxt: string = '';
  colorTxt: string = '';
  provinceTxt: string = '';

  licenseFilteredPlateList: MyVehicleAllResponse[] = [];
  selectLicensePlate: MyVehicleAllResponse[] = [];
  insertLicensePlate: licenseInsertList = {
    license: '',
    brand: '',
    model: '',
    color: '',
    province: '',
  };
  showModalVehiclePlate: boolean = false;

  constructor(
    private apiService: ApiService,
    private apiFormService: ApiFormService,
    private router: Router,
    private cookieService: CookieService,
    private http: HttpClient,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.user_id = parseInt(this.cookieService.get('user_id'));
    this.user_name = this.cookieService.get('name');
    const now = new Date();
    // กำหนดวันนี้
    this.today = now.toISOString().split('T')[0]; // YYYY-MM-DD

    // ❌ ถ้าไม่อยากให้ต่ำกว่าวันนี้ ไม่ต้องใช้ 3 เดือนที่แล้ว
    this.minStartDate = this.today;
    setTimeout(() => {
      this.getUserCityParking();
      this.getProviders();
      this.requestGetCarDetail();
      this.getFeeType();
    }, 0);

    setTimeout(() => {
      forkJoin({
        tambons: this.http.get<any[]>('json/thai_tambons.json'),
        amphures: this.http.get<any[]>('json/thai_amphures.json'),
        provinces: this.http.get<any[]>('json/thai_provinces.json'),
      }).subscribe({
        next: (response) => {
          this.tambons = response.tambons;
          this.amphures = response.amphures;
          this.provincess = response.provinces;

          // setTimeout(() => {
          //   this.getApiAddressAll();
          // }, 100);
        },
        error: (err) => {
          console.error('โหลดข้อมูลล้มเหลว', err);
        },
      });
    }, 1000);
  }

  filteredProviders(): Providers[] {
    if (!this.searchProvider) return this.allProviders;
    return this.allProviders.filter((p) =>
      p.name.toLowerCase().includes(this.searchProvider.toLowerCase())
    );
  }

  filteredMemberCard(): MyMemberCard[] {
    if (!this.searchMemberCard) return this.allMemberCard;
    return this.allMemberCard.filter((p) =>
      p.name.toLowerCase().includes(this.searchMemberCard.toLowerCase())
    );
  }

  get filteredMembers(): MemberLineResponse[] {
    return this.allMembers.filter(
      (m) =>
        m.name.toLowerCase().includes(this.search.toLowerCase()) ||
        m.phone.includes(this.search) ||
        m.fullName.includes(this.search)
    );
  }

  get pagedMembers(): MemberLineResponse[] {
    const start = (this.page - 1) * this.pageSize;
    return this.filteredMembers.slice(start, start + this.pageSize);
  }

  get totalPages(): number {
    return Math.ceil(this.filteredMembers.length / this.pageSize);
  }

  renew(member: MemberLineResponse) {
    this.renew_ = true;
    this.clearRegisterModal();
    this.clearText();
    this.selectMember = member;
    this.getUserVehicle(this.selectMember.lineId);
    this.getApiAddressAll(this.selectMember.lineId);
    // this.getUserVehicleAll(this.selectMember.lineId);
  }

  register(member: MemberLineResponse) {
    this.renew_ = false;
    // //console.log(member);
    this.clearRegisterModal();
    this.clearText();
    this.selectMember = member;
    this.getUserVehicle(this.selectMember.lineId);
    this.getApiAddressAll(this.selectMember.lineId);
    // this.getUserVehicleAll(this.selectMember.lineId);
  }

  closedRegister() {
    this.selectMember = null;
    this.modalRegister = false;
  }

  submitForm() {
    this.modalRegister = false;
  }

  openLocationModal() {
    this.modalSelectProvider = true;
  }

  openMemberCardModal() {
    this.modalSelectMemberCard = true;
    //console.log(this.selectMember);
    const uid = this.selectMember?.lineId;
    if (this.providerId > 0) {
      this.getMemberCardApi(this.providerId, uid ?? '');
      this.getUserVehicleAll();
    } else {
    }
  }

  selectProvider(provider: Providers) {
    this.modalSelectProvider = false;
    this.providerId = provider.id;
    this.providerName = provider.name;
    //console.log(this.providerId);
    setTimeout(() => {
      this.getFeeDetails(this.providerId);
      this.getBank(this.providerId);
      this.carFilteredPlateList = [];
      this.selectCarPlate = [];
      this.getUserVehicleAll();
    }, 200);
  }

  getUserVehicleAll() {
    //console.log('providerId', this.providerId);
    if (this.renew_) {
      //console.log('Re NEW');
      // this.getUserVehicleAllByCardCode();
      // this.apiService
      //   .getVehicleMemberInfo(
      //     this.selectMember?.lineId || '',
      //     this.providerId,
      //     this.card
      //   )
      //   .subscribe({
      //     next: (response: MyVehicleAllResponse[]) => {
      //       //console.log('MyVehicleAllResponse', response);
      //       this.setValueVehicle(response);
      //     },
      //     error: (error) => {
      //       console.error('API error:', error);
      //       this.isLoading = false;
      //     },
      //   });
    } else {
      //console.log('NEW');
      this.apiService.getVehicleUserAllBySite(
        this.selectMember?.lineId || '',
        this.providerId
      )
        .subscribe({
          next: (response: MyVehicleAllResponse[]) => {
            //console.log('MyVehicleAllResponse', response);
            this.setValueVehicle(response);
          },
          error: (error) => {
            console.error('API error:', error);
            this.isLoading = false;
          },
        });
    }
  }

  // get Vehicle by CardCode
  getUserVehicleAllByCardCode() {
    this.apiService
      .getVehicleMemberInfo(
        this.selectMember?.lineId || '',
        this.providerId,
        this.CardCode || ''
      )
      .subscribe({
        next: (response: MyVehicleAllResponse[]) => {
          //console.log('MyVehicleAllResponse', response);
          this.setValueVehicle(response);
          response.forEach((vehicle) => {
            this.selectCarPlate.push(vehicle);
          });
        },
        error: (error) => {
          console.error('API error:', error);
          this.isLoading = false;
        },
      });
  }

  setValueVehicle(response: MyVehicleAllResponse[]) {
    // --- กรองข้อมูลทะเบียนรถ ---
    this.licenseAll = response;
    //console.log('licenseAll', this.selectVehicleType);
    // ใส่ป้ายทะเบียนเริ่มต้น
    this.carPlateList = this.licenseAll.filter(
      (item) => item.vehicle_type_name === this.selectVehicleType
    );
    if (this.renew_) {
      this.selectLicensePlate = this.carPlateList;
    }
    //this.selectLicensePlate = this.carPlateList;
    //console.log('carPlateList', this.carPlateList);
    this.handleSelectVehicleType(this.selectVehicleType);
  }

  selectMemberCard(member: MyMemberCard) {
    this.modalSelectMemberCard = false;
    if (member) {
      //console.log('member info ', member);
      this.selectMemberCard_ = member;
      this.CardCode = this.selectMemberCard_.card_code || '';
      this.cardMemberName = this.selectMemberCard_?.card_name || '';
      this.expire_date = this.selectMemberCard_.expire_date || '';
      this.selectVehicleType = this.selectMemberCard_.vehicle_type || '';
      //console.log('expire_date', this.expire_date);
      this.getUserVehicleAllByCardCode();
      // this.license = this.selectMemberCard_.plate_number;
      // this.selectedLicense = this.license;
      // this.changeLicense(this.selectedLicense);
    } else {
      //console.log('No data');
    }

    // this.providerId = provider.id;
    // this.providerName = provider.name;
    // //console.log(this.providerId);
    // setTimeout(() => {
    //   this.getFeeDetails(this.providerId);
    //   this.getBank(this.providerId);
    // }, 200);
  }

  clearSearch() {
    this.searchMemberCard = '';
  }

  handleSelectVehicleType(vehicleType: string): void {
    //console.log(vehicleType);
    this.selectVehicleType = vehicleType;
    const selectedOption = this.CarOptions.find(
      (option) => option.value === vehicleType
    );
    if (selectedOption) {
      this.CardOptions = [];
      this.selectedOption = null;
      this.subscription_id = 0;
      this.selectedCar = vehicleType;

      if (this.selectVehicleType !== vehicleType) {
        this.selectCarPlate = [];
        this.fig_day = 0;
        this.subscription_id = 0;
        this.fee = 0;
      }

      this.CardOptions = this.fullFeeList
        .filter((fee) => fee.vehicle_name === this.selectedCar)
        .map((fee) => ({
          value: fee.id,
          label: `${fee.name} ( ${fee.fee} บาท )`,
          fig_day: fee.fig_day,
          vehicle_type_name: fee.vehicle_name,
          subscription_id: fee.subscription_id,
        }));
      //console.log('licenseAll Vehicle: ', this.licenseAll);

      // Filter Vehicle plate list
      this.carPlateList = this.licenseAll.filter(
        (vehicle) => vehicle.vehicle_type_name === this.selectVehicleType
      );

      //console.log('carPlateList : ', this.carPlateList);

      //console.log('CardOptions', this.CardOptions);
      //console.log('selectedOption', this.selectedOption);
      this.updateBrandOptions(selectedOption.value, '');
    }
  }

  setCard() {
    this.CardOptions = this.fullFeeList
      .filter((fee) => fee.vehicle_name === this.selectedCar)
      .map((fee) => ({
        value: fee.id,
        label: `${fee.name} ( ${fee.fee} บาท )`,
        fig_day: fee.fig_day,
        vehicle_type_name: fee.vehicle_name,
        subscription_id: fee.subscription_id,
      }));
  }

  updateBrandOptions(vehicleType: string, preselectBrand?: string): void {
    const filteredBrands = this.vehicleDetails
      .filter((vehicle) => vehicle.vehicle_type_name === vehicleType)
      .map((vehicle) => vehicle.vehicle_brand_name);

    const uniqueBrands = [...new Set(filteredBrands)];
    this.selectedBrand = '';
    this.selectedModel = '';

    this.BrandOptions = uniqueBrands.map((brand) => ({
      value: brand,
      label: brand,
    }));

    // ✅ ถ้ามีค่าที่ต้องการเลือกไว้ล่วงหน้า
    if (preselectBrand) {
      // //console.log('เลือกแบร์นมา ', preselectBrand);
      const defaultBrand = this.BrandOptions.find(
        (opt) => opt.value === preselectBrand
      );
      this.selectedBrand = defaultBrand ? defaultBrand.value : null;
    }
  }

  handlePackChange(value: number | string): void {
    const numericValue =
      typeof value === 'string' ? parseInt(value, 10) : value;
    // //console.log('🔄 handlePackChange:', numericValue);

    const selected = this.CardOptions.find(
      (option) => option.value === numericValue
    );
    // //console.log('🎯 selectedOption:', selected);
    this.selectedOption = numericValue;
    if (selected) {
      this.fig_day = selected.fig_day;
      this.subscription_id = selected.subscription_id;
      // //console.log('✅ Selected Option ID:', numericValue);
      // //console.log('📆 Selected FigDay:', this.fig_day);
      // //console.log('📆 Selected subscription:', this.subscription_id);
    } else {
      this.fig_day = null;
      // console.warn('⚠️ ไม่พบ option ที่เลือก');
    }
  }

  filterNumberOnly(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
    this.phoneNo = input.value;
  }
  validateForm() {
    const phoneValid = /^0[0-9]{9}$/.test(this.phoneNo);
    this.error = phoneValid ? '' : 'เบอร์ไม่ถูกต้อง';
  }
  handleCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    //console.log('checkbox checked:', checked);
    // เพิ่ม logic ได้ที่นี่ เช่น เก็บค่าไว้ใน form
  }
  changeLicense(plate: string) {
    this.license = plate;
    this.modalSelectVehicle = false;
    const selectedVehicle = this.licenseAll.find(
      (item) => item.plate_number === plate
    );

    if (selectedVehicle) {
      // //console.log('✅ ข้อมูลรถที่เลือก:', selectedVehicle);
      this.changeUpdateOptionCar(
        selectedVehicle.province_name,
        selectedVehicle.vehicle_type_name,
        selectedVehicle.color_name,
        selectedVehicle.brand_name,
        selectedVehicle.model_name
      );
    } else {
      //console.log('❌ ไม่พบทะเบียน:', plate);
    }
  }
  changeUpdateOptionCar(
    province_name: string,
    vehicle_type_name: string,
    color_name: string,
    brand_name: string,
    model_name: string
  ) {
    if (!this.licenseAll || this.licenseAll.length === 0) {
      //console.log('❌ ไม่มีข้อมูลรถ');
      return;
    }

    // 🏷️ จังหวัด
    const matchProvince = this.ProvinceOptions.find(
      (p) => p.value === province_name
    );
    if (matchProvince) {
      this.selectedProvince = matchProvince;
    }

    // 🚗 ประเภทรถ
    const defaultCar = this.CarOptions.find(
      (opt) => opt.value === vehicle_type_name
    );
    this.selectedCar = defaultCar ? defaultCar.value : null;

    // 💳 ค่าบริการ
    this.CardOptions = this.fullFeeList
      .filter((fee) => fee.vehicle_name === this.selectedCar)
      .map((fee) => ({
        value: fee.id,
        label: `${fee.name} ( ${fee.fee} บาท )`,
        fig_day: fee.fig_day,
        vehicle_type_name: fee.vehicle_name,
        subscription_id: fee.subscription_id,
      }));

    // 🏷️ อัปเดตยี่ห้อรถ และตั้งค่า selectedBrand
    this.updateBrandOptions(this.selectedCar || '', brand_name);

    // ✅ model ต้องรอ selectedBrand ถูก set แล้ว จึงค่อยเรียก updateModelOptions
    if (brand_name) {
      const brandExists = this.BrandOptions.find(
        (opt) => opt.value === brand_name
      );
      this.selectedBrand = brandExists ? brandExists.value : null;

      // ✅ เรียกหลังจาก selectedBrand ถูกตั้งค่าแล้ว
      this.updateModelOptions(this.selectedBrand || '');

      const defaultModel = this.ModelOptions.find(
        (opt) => opt.value === model_name
      );
      this.selectedModel = defaultModel ? defaultModel.value : null;
    }

    // 🎨 สี
    const defaultColor = this.ColorOptions.find(
      (opt) => opt.value === color_name
    );
    this.selectedColor = defaultColor ? defaultColor.value : null;
  }
  updateModelOptions(brand: string): void {
    // กรองข้อมูลตามประเภทที่เลือก
    const filteredModel = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === brand &&
          brands.vehicle_type_name === this.selectedCar
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_model_name); // ดึงแค่ vehicle_brand_name

    // กรองค่าซ้ำจาก filteredBrands
    const uniqueBrands = [...new Set(filteredModel)];
    this.selectedModel = '';
    this.selectEngine = '';
    // อัปเดต BrandOptions โดยใช้ค่าที่ไม่ซ้ำดอ
    this.ModelOptions = uniqueBrands.map((model) => ({
      value: model,
      label: model,
    }));
  }
  filterProvinces() {
    return this.ProvinceOptions.filter((ProvinceOptions) =>
      ProvinceOptions.label
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase())
    );
  }
  selectProvince(province: any) {
    // this.insertLicensePlate.province = province.value;
    this.provinceTxt = province.value;
    this.isOpen = false;
    //console.log('เลือกจังหวัด:', province);
  }
  handleBrandChange(event: any): void {
    this.selectedBrand = event.target.value;
    //console.log('Selected Brand ID:', this.selectedBrand);
    this.updateModelOptions(this.selectedBrand || '');
  }
  handleFeeType(event: any): void {
    const selectedValue = +event.target.value; // แปลงเป็น number
    this.selectedFeeType = selectedValue;
    const selectedOption = this.FeeTypeOptions.find(
      (opt) => opt.value === selectedValue
    );
    this.showBank = selectedOption?.status ?? false;
    //console.log('Selected FeeType ID:', this.selectedFeeType);
  }
  handleAccount(event: any): void {
    this.selectedAccountId = event.target.value;
  }
  handleModelChange(event: any): void {
    this.selectedModel = event.target.value;
    this.selectEngine = '';
    //console.log('Selected Model ID:', this.selectedModel);

    const filteredEngines = this.vehicleDetails
      .filter(
        (brands) =>
          brands.vehicle_brand_name === this.selectedBrand &&
          brands.vehicle_type_name === this.selectedCar &&
          brands.vehicle_model_name === this.selectedModel
      ) // กรองตามประเภทที่เลือก
      .map((brands) => brands.vehicle_engine_name);

    this.selectEngine = filteredEngines[0] || '';
    //console.log('Selected Engine:', this.selectEngine);
  }
  handleColorChange(event: any): void {
    this.selectedColor = event.target.value;
    //console.log('Selected Color ID:', this.selectedColor);
    // this.updateModelOptions(this.selectedBrand || '');
  }
  openTaxModal() {
    this.showTaxModal = true;
  }
  closeTaxModal() {
    this.showTaxModal = false;
  }
  filterAddressByTaxType(): void {
    this.filteredAddressList = [];
    this.selectedAddress = null;
    this.address_id = 0;
    const type = parseInt(this.selectedTaxType, 10); // แปลงเป็น number
    this.filteredAddressList = this.addressListAll.filter(
      (item) => item.address_user_type === type
    );
    //console.log( "Select Tax Type :", this.selectedTaxType );
    if (this.filteredAddressList.length > 0) {
      this.showSelectAddress = true;
      this.selectedAddress = this.filteredAddressList[0];
      this.setValueAddress();
    } else {
      this.showSelectAddress = false;
      this.selectedAddress = null;
      this.setValueAddress();
    }
  }
  setValueAddress() {
    if (this.selectedAddress) {
      this.address_id = this.selectedAddress.id;
      this.mainOffice = this.selectedAddress.headquarters;
      this.taxName = this.selectedAddress.name;
      this.tax_phone = this.selectedAddress.phone;
      this.email = this.selectedAddress.email;
      this.branchName = this.selectedAddress.branch;
      this.branchNo = this.selectedAddress.branch_no;
      this.taxId = this.selectedAddress.tax_id;
      this.address = this.selectedAddress.address;
      this.tax_phone = this.selectedAddress.phone;

      const selectedProvName = this.selectedAddress?.provinces?.trim() ?? '';
      const matchedProvince = this.provincess.find(
        (p) => p.name_th.trim() === selectedProvName
      );
      if (matchedProvince) {
        this.selectedProvinceId = matchedProvince.id;
        this.province_name = selectedProvName;
      } else {
        this.selectedProvinceId = null;
        this.province_name = '';
      }

      if (this.selectedProvinceId != null) {
        const provinceId = this.selectedProvinceId;
        this.filteredAmphures = this.amphures.filter(
          (a) => a.province_id === +provinceId
        );

        const selectedAmphureName =
          this.selectedAddress?.district?.trim() ?? '';
        const matchedAmphure = this.filteredAmphures.find(
          (a) => a.name_th.trim() === selectedAmphureName
        );
        if (matchedAmphure) {
          this.selectedAmphureId = matchedAmphure.id;
          this.amphure_name = selectedAmphureName;
        } else {
          this.selectedAmphureId = null;
          this.amphure_name = '';
        }
      } else {
        this.filteredAmphures = [];
        this.selectedAmphureId = null;
        this.amphure_name = '';
      }

      if (this.selectedAmphureId != null) {
        const amphureId = this.selectedAmphureId;

        // กรองตำบลในอำเภอที่เลือก
        this.filteredTambons = this.tambons.filter(
          (a) => a.amphure_id === +amphureId
        );

        // ดึงชื่อจากที่อยู่
        const selectedTambonName =
          this.selectedAddress?.sub_district?.trim() ?? '';

        // หาใน list ว่าตรงกับตำบลไหน
        const matchedTambon = this.filteredTambons.find(
          (a) => a.name_th.trim() === selectedTambonName
        );

        if (matchedTambon) {
          this.selectedTambonId = matchedTambon.id;
          this.tambon_name = selectedTambonName;
          this.zipcode = this.selectedAddress.zip_code;
        } else {
          this.selectedTambonId = null;
          this.tambon_name = '';
          this.zipcode = '';
        }
      } else {
        this.filteredTambons = [];
        this.selectedTambonId = null;
        this.tambon_name = '';
      }
    } else {
      // ✅ ล้างค่าเมื่อไม่มี selectedAddress
      this.address_id = 0;
      this.mainOffice = false;
      this.taxName = '';
      this.tax_phone = '';
      this.email = '';
      this.branchName = '';
      this.branchNo = '';
      this.taxId = '';
      this.address = '';
      this.zipcode = '';
      this.selectedProvinceId = null;
      this.province_name = '';
      this.filteredAmphures = [];
      this.selectedAmphureId = null;
      this.amphure_name = '';
      this.filteredTambons = [];
    }
  }
  openAddressModal() {
    this.showAddressModal = true;
  }
  onAmphureChange() {
    this.selectedTambonId = null;
    this.zipcode = '';
    this.tambon_name = '';
    this.filteredTambons =
      (this.selectedAmphureId ?? null) !== null
        ? this.tambons.filter((a) => a.amphure_id === +this.selectedAmphureId!)
        : [];
    if (this.amphures.length && this.selectedAmphureId) {
      const amphure = this.amphures.find(
        (a) => a.id === Number(this.selectedAmphureId)
      );
      this.amphure_name = amphure ? amphure.name_th : '';
      // //console.log('✅ amphure_name:', this.amphure_name);
    }
  }

  onTambonsChange() {
    // //console.log(this.selectedTambonId);
    this.zipcode = '';
    this.zipcode =
      (this.selectedTambonId ?? null) !== null
        ? this.tambons.filter((t) => t.id === +this.selectedTambonId!)[0]
          ?.zip_code || ''
        : '';

    if (this.tambons.length && this.selectedTambonId) {
      const tambon = this.tambons.find(
        (a) => a.id === Number(this.selectedTambonId)
      );
      this.tambon_name = tambon ? tambon.name_th : '';
      // //console.log(this.tambon_name);
    }
  }
  onProvinceChange() {
    // //console.log(this.selectedProvinceId);
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.amphure_name = '';
    this.tambon_name = '';
    this.filteredAmphures =
      (this.selectedProvinceId ?? null) !== null
        ? this.amphures.filter(
          (a) => a.province_id === +this.selectedProvinceId!
        )
        : [];
    if (this.provincess.length && this.selectedProvinceId) {
      const province = this.provincess.find(
        (a) => a.id === Number(this.selectedProvinceId)
      );
      this.province_name = province ? province.name_th : '';
      // //console.log('✅ province_name:', this.province_name);
    } else {
      console.warn('⚠️ province list or selectedProvinceId not ready');
    }

    this.filteredTambons = []; // reset
  }

  summit() {
    this.showTaxModal = false;
  }



  clearRegisterModal() {
    this.providerName = '';
    this.CardCode = '';
    this.cardMemberName = '';
    this.providerId = 0;
    this.selectedCar = null;
    this.selectedFile = null;
    this.previewUrl = null;
    this.selectedFeeType = null;
    this.startDate = null;
    this.CardOptions = [];
    this.customer_name = '';
    this.phoneNo = '';
    this.licenseAll = [];
    this.license = '';
    this.selectedProvince = null;
    this.selectedBrand = '';
    this.selectedModel = '';
    this.selectedColor = '';
    this.isRequestTax = false;
    this.remarks = '';
    this.selectedTaxType = '1';
    this.mainOffice = false;
    this.taxName = '';
    this.tax_phone = '';
    this.email = '';
    this.branchName = '';
    this.branchNo = '';
    this.taxId = '';
    this.address = '';
    this.selectedProvinceId = null;
    this.selectedAmphureId = null;
    this.selectedTambonId = null;
    this.zipcode = '';
    this.base64String = '';
    this.selectedFeeType = null;
    this.BankOptions = [];
    this.selectedAccountId = 0;
    this.showBank = false;

    this.carPlateList = [];
    this.carFilteredPlateList = [];
    this.selectedCar = null
    this.selectLicensePlate = [];
  }
  clearText() {
    this.licenseTxt = '';
    this.provinceTxt = '';
    this.brandTxt = '';
    this.modelTxt = '';
    this.colorTxt = '';
    this.selectedBrand = '';
    this.ModelOptions = [];
    this.selectedModel = '';
    this.selectEngine = '';
    this.selectedColor = '';

    this.clearRegisterModal();
  }
  selectAddress(item: any) {
    this.selectedAddress = item;
    this.showAddressModal = false;
    this.setValueAddress();
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        // แปลงเป็น base64 string
        const result = reader.result as string;
        const base64 = result.split(',')[1]; // ตัด header ออก เช่น "data:image/png;base64,"
        this.base64String = base64;
      };

      reader.readAsDataURL(this.selectedFile);
    }
  }

  uploadImage() {
    if (!this.selectedFile) {
      Swal.fire({
        icon: 'warning',
        title: 'เกิดข้อผิดพลาด',
        text: 'กรุณาเลือกไฟล์ก่อน',
      });
      return;
    }

    const formData = new FormData();
    formData.append('image', this.selectedFile);

    // ตัวอย่างการส่งไป API
    this.http.post('/api/upload', formData).subscribe({
      next: (res) => {
        //console.log('อัปโหลดสำเร็จ', res);
      },
      error: (err) => {
        console.error('เกิดข้อผิดพลาด', err);
      },
    });
  }
  submitRequest() {
    //console.log(this.startDate);
    if (!this.providerName.trim()) {
      this.toast.warn('กรุณาเลือกสถานที่ให้บริการ');
    } else if (!this.selectedFeeType) {
      this.toast.warn('กรุณาเลือกประเภทการรับชำระ');
    } else if (this.showBank && this.selectedAccountId == 0) {
      this.toast.warn('กรุณาเลือกหมายเลขบัญชี');
    } else if (!this.startDate) {
      this.toast.warn('กรุณาระบุวันที่เริ่มต้นใช้งาน');
    } else if (!this.selectedOption) {
      this.toast.warn('กรุณาเลือกแพ็คเกจ');
    } else if (!this.customer_name.trim()) {
      this.toast.warn('กรุณาระบุชื่อผู้สมัคร');
    } else if (!this.phoneNo.trim()) {
      this.toast.warn('กรุณาระบุเบอร์โทรศัพท์');
    } else if (this.selectLicensePlate.length <= 0) {
      this.toast.warn('กรุณาเลือกทะเบียนรถ');
    } else if (this.isRequestTax) {
      if (
        !this.taxName.trim() &&
        !this.taxId.trim() &&
        !this.address.trim() &&
        this.selectedProvinceId === null &&
        this.selectedAmphureId === null &&
        this.selectedTambonId === null
      ) {
        this.toast.error('กรุณาเพิ่มข้อมูลใบกำกับภาษีก่อน');
      } else if (!this.taxName.trim()) {
        this.toast.error('กรุณาระบุ ชื่อผู้เสียภาษี');
      } else if (
        !this.branchName.trim() &&
        !this.branchNo.trim() &&
        !this.mainOffice &&
        this.selectedTaxType === '2'
      ) {
        //console.log();
        this.toast.warn('กรุณาระบุ สาขาและรหัสสาขา');
      } else if (!this.taxId.trim()) {
        this.toast.warn('กรุณาระบุ เลขประจำตัวผู้เสียภาษี');
      } else if (!this.address.trim()) {
        this.toast.warn('กรุณาระบุ ที่อยู่');
      } else if (!this.tax_phone.trim()) {
        this.toast.warn('กรุณาระบุ เบอร์โทรศัพท์ ใบกำกับภาษี');
      } else if (this.selectedProvinceId === null) {
        this.toast.warn('กรุณาระบุ จังหวัด');
      } else if (this.selectedAmphureId === null) {
        this.toast.warn('กรุณาระบุ อำเภอ');
      } else if (this.selectedTambonId === null) {
        this.toast.warn('กรุณาระบุ ตำบล');
      } else if (!this.zipcode) {
        this.toast.warn('กรุณาระบุ เลขไปรษณีย์');
      } else {
        this.confirmSaveData();
        // if (this.vehicleId > 0) {
        //   if (this.originalDate && this.startDate) {
        //     const original = new Date(this.originalDate);
        //     const start = new Date(this.startDate);
        //     original.setHours(0, 0, 0, 0);
        //     start.setHours(0, 0, 0, 0);
        //     if (start > original) {
        //       this.showModal_confirm = true;
        //     } else {
        //       this.toast.warning('วันที่เริ่มจะต้องมากกว่าวันหมดอายุเดิม');
        //     }
        //   } else {
        //     this.toast.error('การตรวจสอบวันเริ่มใช้งานมีปัญหา');
        //   }
        // } else {
        //   // this.showModal_confirm = true;
        // }
      }
    } else {
      this.confirmSaveData();
      // //console.log('No Tax !');
      // if (this.vehicleId > 0) {
      //   if (this.originalDate && this.startDate) {
      //     const original = new Date(this.originalDate);
      //     const start = new Date(this.startDate);
      //     original.setHours(0, 0, 0, 0);
      //     start.setHours(0, 0, 0, 0);
      //     if (start > original) {
      //       this.showModal_confirm = true;
      //     } else {
      //       this.toast.warning('วันที่เริ่มจะต้องมากกว่าวันหมดอายุเดิม');
      //     }
      //   } else {
      //     this.toast.error('การตรวจสอบวันเริ่มใช้งานมีปัญหา');
      //   }
      // } else {
      //   this.showModal_confirm = true;
      // }
      // this.saveMemberRegister();
    }

    // this.openModal_Confirm();
  }

  confirmSaveData() {
    Swal.fire({
      icon: 'warning',
      title: 'แน่ใจหรือไม่?',
      text: 'คุณได้ตรวจสอบข้อมูลแล้ว ต้องการดำเนินการต่อหรือไม่?',
      showCancelButton: true,
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก',
      reverseButtons: true, // ให้ปุ่มตกลงอยู่ขวา ยกเลิกอยู่ซ้าย
    }).then((result) => {
      if (result.isConfirmed) {
        // ✅ ผู้ใช้กด "ตกลง"
        // //console.log('ดำเนินการต่อ...');
        this.saveMemberRegister();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // ❌ ผู้ใช้กด "ยกเลิก"
        //console.log('ยกเลิกการทำงาน');
      }
    });
  }

  openModelVehicle() {
    this.modalSelectVehicle = true;
  }
  getAddressByTaxId() {
    if (!this.taxId.trim()) {
      this.toast.warn('กรุณาระบุเลขผู้เสียภาษีก่อน');
    } else {
      this.isLoading = true;
      this.ApigetAddressByTaxId();
    }
  }

  //Vehicle Plate
  filterCarPlate(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.carFilteredPlateList = this.carPlateList.filter((vehicle) =>
      vehicle.plate_number.toLowerCase().includes(searchTerm)
    );
  }
  isSelected(plate: string): boolean {
    return this.selectLicensePlate
      .map((item) => item.plate_number)
      .includes(plate);
  }


  // Excel import
  onExcelFileSelected(event: any): void {
    const target: DataTransfer = <DataTransfer>event.target;
    if (target.files.length !== 1) {
      console.error('กรุณาเลือกไฟล์เพียงไฟล์เดียว');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const binaryStr: string = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(binaryStr, { type: 'binary' });

      const sheetName: string = workbook.SheetNames[0]; // ใช้ชีทแรก
      const worksheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      var dataInfoList: licenseInsertList[] | any = [];

      // แปลงข้อมูลเพิ่มเข้า list
      data.forEach((row: any) => {
        if (
          row['plate_number'] != '' &&
          row['province_name'] != '' &&
          row['brand_name'] != '' &&
          row['model_name'] != '' &&
          row['color_name'] != ''
        ) {
          const newItem: licenseInsertList = row;
          dataInfoList.push(newItem);

          // เพิ่มแบบเปลี่ยน reference
          //this.licenseAll = [...this.licenseAll, newItem];
        }
      });

      this.sentLincenseInsert(dataInfoList);
      //console.log('นำเข้าข้อมูลสำเร็จ', dataInfoList);
    };

    reader.readAsBinaryString(target.files[0]);
  }



  /* ------------------------------------------- Modal Register ------------------------------------------ */
  onCloseRegisterModal() {
    this.modalRegister = false;
    this.selectMember = null;
    this.clearRegisterModal();
  }



  /* ------------------------------------------- Modal Vehicle Plate ------------------------------------------ */

  // Click from list Vehicle
  toggleSelect(vehicle: MyVehicleAllResponse, event: Event) {
    event.stopPropagation(); // ป้องกันไม่ให้ blur แล้ว dropdown ปิด

    const index = this.selectLicensePlate
      .map((item) => item.plate_number)
      .indexOf(vehicle.plate_number);

    if (index > -1) {
      this.selectLicensePlate.splice(index, 1);
    } else {
      // เพิ่ม Model ลงใน selectLicensePlate
      this.selectLicensePlate.push(vehicle);

      //console.log('✅ Selected Plates ! :', this.selectLicensePlate);
    }
  }

  openModalVehiclePlate() {
    this.showModalVehiclePlate = true;
  }
  closeModalVehiclePlate() {
    this.showModalVehiclePlate = false;
    this.onClearVehiclePlateModal();
  }
  onClearVehiclePlateModal() {
    this.licenseTxt = '';
    this.provinceTxt = '';
    this.brandTxt = '';
    this.modelTxt = '';
    this.colorTxt = '';
    this.selectedBrand = '';
    this.ModelOptions = [];
    this.selectedModel = '';
    this.selectEngine = '';
    this.selectedColor = '';
  }

  // Modal license plate
  submitModalVehiclePlate() {
    // Insert License
    if (this.licenseTxt == '') {
      this.toast.warn('กรุณาระบุทะเบียนรถ');
    } else if (this.provinceTxt == '') {
      this.toast.warn('กรุณาระบุเลขจังหวัด');
    } else if (this.brandTxt == '') {
      this.toast.warn('กรุณาระบุแบรนด์รถ');
    } else if (this.modelTxt == '') {
      this.toast.warn('กรุณาระบุทะรุ่นรถ');
    } else if (this.colorTxt == '') {
      this.toast.warn('กรุณาระบุสีรถ');
    } else {
      const payload: InsertLicensePayload = {
        uid: this.selectMember?.lineId || '',
        license: this.licenseTxt.replace(/\s+/g, ''),
        vehicle_type: this.selectVehicleType || '',
        brand: this.selectedBrand || '',
        model: this.selectedModel || '',
        engine_type: this.selectEngine || '',
        color: this.selectedColor || '',
        province: this.provinceTxt,
      };
      //console.log("JSON payload sentLincenseInsert :",JSON.stringify(payload));
      if (payload) {
        this.sentLincenseInsert(payload);
      } else {
        //console.log('No Payload');
      }
    }

    // this.showModalVehiclePlate = false;
    // Render HTML don't use push
    // this.licenseFilteredPlateList = [...this.licenseFilteredPlateList, this.newLicensePlate];
    // //console.log('New license : ' , this.newLicensePlate , this.licenseAll);
  }



  /* -------------------------------------------- API ----------------------------------------------- */
  getFeeType() {
    this.apiFormService.getFeeType().subscribe({
      next: (response: FeeType[]) => {
        //console.log('getFeeType', response);
        this.FeeTypeOptions = response.map((feetype) => ({
          value: feetype.id,
          label: feetype.name,
          status: feetype.requestBank || false,
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  getBank(site_id: number) {
    //console.log('getBank', site_id);
    this.apiFormService.getBank(site_id).subscribe({
      next: (response: Blank[]) => {
        this.BankOptions = response.map((bank) => ({
          value: bank.id,
          label: bank.bankName + ' (' + bank.accountNumber + ')',
        }));
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  getProviders() {
    this.apiFormService.getProviders().subscribe({
      next: (res) => {
        Swal.close();
        // //console.log('res : ', res);
        this.allProviders = res;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        Swal.close();
      },
    });
  }

  getFeeDetails(site_id: number) {
    this.apiService.getFeeDetails(site_id).subscribe({
      next: (response: FeeDetailsResponse[]) => {
        this.fullFeeList = response;
        this.CardOptions = []; // เริ่มต้นว่างก่อนรอเลือกประเภทรถ
        this.setCard();
      },
      error: (error) => {
        console.error('API error:', error);
      },
    });
  }

  requestGetCarDetail() {
    this.isLoading = true;
    this.apiService.getCarDetail().subscribe({
      next: (response: InformationResponse) => {
        // //console.log('date :', response);
        this.vehicleDetails = response.vehicle_detail;
        this.ColorOptions = response.color.map((color: Color) => ({
          value: color.name.toLowerCase(),
          label: color.name,
        }));
        this.ProvinceOptions = response.province.map((province: Province) => ({
          value: province.name.toLowerCase(),
          label: province.name,
        }));

        this.CarOptions = [
          ...new Set(
            response.vehicle_detail.map((vehicleDetail: VehicleDetail) =>
              vehicleDetail.vehicle_type_name.toLowerCase()
            )
          ),
        ].map((vehicleTypeName: string) => ({
          value: vehicleTypeName,
          label:
            vehicleTypeName.charAt(0).toUpperCase() + vehicleTypeName.slice(1), // แสดงผลให้เป็นตัวพิมพ์ใหญ่ที่ตัวแรก
        }));

        // setTimeout(() => {
        //   this.getUserVehicle();
        //   this.getUserVehicleAll();
        // }, 100);

        this.isLoading = false;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }


  //สมัครบัตรใหม่
  getUserVehicle(uid: string) {
    this.apiService.getUserVehicle(uid).subscribe({
      next: (response: UserVehicleResponse) => {
        this.modalRegister = true;

        // //console.log('UserVehicleResponse', response);
        if (response.code === '000') {
          this.license = response.data.license;
          this.customer_name = response.data.full_name;
          this.phoneNo = response.data.phone_number;
        } else {
          // //console.log('UserVehicleResponse', 'No data');
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  getApiAddressAll(uid: string) {
    this.address_id = 0;
    //console.log('UID', uid);
    this.apiService.getMyAddress(uid).subscribe({
      next: (response: MyAddressAllResponse[]) => {
        this.addressListAll = response;
        this.selectedAddress = null;
        if (this.addressListAll.length > 0) {
          this.showSelectAddress = true;

          const type = 1; // แปลงเป็น number
          this.filteredAddressList = this.addressListAll.filter(
            (item) => item.address_user_type === type
          );
          this.selectedAddress = this.filteredAddressList[0];
          this.setValueAddress();
        } else {
          this.showSelectAddress = false;
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
  getUserCityParking() {
    Swal.fire({
      title: 'กำลังดึงข้อมูล...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    this.apiService.getMemberLine().subscribe({
      next: (res) => {
        Swal.close();
        // //console.log('res : ', res);
        this.allMembers = res;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        Swal.close();
      },
    });
  }
  getMemberCardApi(site_id: number, uid: string) {
    this.apiService.getMyMemberCard(uid, site_id).subscribe({
      next: (response: MyMemberCard[]) => {
        //console.log(response);
        this.allMemberCard = response;
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }

  // License insert
  sentLincenseInsert(data: InsertLicensePayload) {
    this.apiService.InsertLicense(data).subscribe({
      next: (res: InsertLicenseResponse) => {
        //console.log('InsertLicense res : ', res);
        if (res.code == '000') {
          this.onClearVehiclePlateModal();

          //this.showModalVehiclePlate = false;
          this.getUserVehicleAll();
          this.toast.success('บีนทึกทะเบียนสำเร็จ');

          // ดึงทะเบียนมาใหม่
          this.requestGetCarDetail();
        } else {
          this.toast.error(res.message);
        }
      },
      error: (err) => {
        console.error('การบันทึกไม่สำเร็จ', err);
        this.toast.error('การบันทึกไม่สำเร็จ');
      },
    });
  }


  // Register Member
  saveMemberRegister() {
    Swal.fire({
      title: 'กำลังบันทึกข้อมูล...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // สร้าง license
    const licensesModel: CarList[] = [];
    //console.log('this.selectLicensePlate : ', this.selectLicensePlate);
    this.selectLicensePlate.forEach((licenseSelect) => {
      licensesModel.push({
        vehicleId: licenseSelect.vehicle_id,
        license: licenseSelect.plate_number,
        province: licenseSelect.province_name,
        vehicleTypeId: licenseSelect.vehicle_type_name,
      });
    });
    // //console.log(licensesModel);

    // สร้าง payload
    if (licensesModel) {
      const payload: RegisterMemberPayload = {
        uid: this.selectMember?.lineId || '',
        name: this.customer_name,
        member_start: this.startDate,
        phone: this.phoneNo,
        vehicle_type: this.selectedCar,
        license: '',
        brand: '',
        model: '',
        color: '',
        province: '',
        remark: this.remarks,
        full_tax: this.isRequestTax,
        full_name: this.taxName,
        address_id: this.address_id,
        address_user_type: parseInt(this.selectedTaxType || '0', 10),
        address: this.address || '',
        sub_district: this.tambon_name || '',
        district: this.amphure_name || '',
        provinces: this.province_name || '',
        zip_code: this.zipcode || '',
        email: this.email || '',
        branch: this.branchName || '',
        branch_no: this.branchNo || '',
        headquarters: this.mainOffice,
        site_id: this.providerId,
        fee_id: this.selectedOption || 0,
        fig_day: this.fig_day,
        subscription_id: this.subscription_id,
        taxId: this.taxId,
        is_default: false,
        register_member_type: !this.renew_ ? 1 : 2,
        phone_tax: this.tax_phone,
        base64: this.base64String,
        fee_type_id: this.selectedFeeType || 0,
        bank_id: this.selectedAccountId || 0,
        request_bank: this.showBank,
        memberVehicles: licensesModel,
      };

      //console.log('Sent to API : ', JSON.stringify(payload).toString());
      if (payload) {
        this.apiService.RegisterMember(payload).subscribe({
          next: (res: StatusAPIResponse) => {
            Swal.close();
            //console.log('📦 Response:', res);
            if (res.code == '000') {
              this.toast.success('สมัครสมาชิกรายเดือนเรียบร้อย');
              this.modalRegister = false;
              this.clearRegisterModal();
            } else {
              this.toast.error(res.message);
            }
          },
          error: (err) => {
            Swal.close();
            console.error('❌  ไม่สำเร็จ:', err);
            this.toast.error('บันทึกไม่สำเร็จ');
          },
          complete: () => {
            Swal.close();
          },
        });
      } else {
        //console.log('payload os null');
      }
    } else {
      //console.log('No Data Vehicles');
    }
  }
  ApigetAddressByTaxId() {
    this.apiService.getAddressByTaxId(this.taxId.trim()).subscribe({
      next: (response: TaxpayerInfo) => {
        this.isLoading = false;
        //  //console.log(JSON.stringify(response).toString());
        if (!response || Object.keys(response).length === 0) {
          this.toast.error('ไม่พบข้อมูลผู้เสียภาษี');
          return;
        } else {
          this.taxName =
            response.company_branch_title_name + ' ' + response.company_name;
          this.address =
            response.company_address_no +
            ' หมู่ที่ ' +
            response.company_moo_number;
          if (response.company_branch_number === '0') {
            this.mainOffice = true;
          } else {
            this.mainOffice = false;
            this.branchName = response.company_branch_name;
          }
          const matchedProvince = this.provincess.find(
            (p) => p.name_th.trim() === response.company_province
          );
          if (matchedProvince) {
            this.selectedProvinceId = matchedProvince.id;
            this.province_name = response.company_province;
          } else {
            this.selectedProvinceId = null;
            this.province_name = '';
          }
          if (this.selectedProvinceId != null) {
            const provinceId = this.selectedProvinceId;
            this.filteredAmphures = this.amphures.filter(
              (a) => a.province_id === +provinceId
            );

            const selectedAmphureName = response.company_amphur;
            const matchedAmphure = this.filteredAmphures.find(
              (a) => a.name_th.trim() === selectedAmphureName
            );
            if (matchedAmphure) {
              this.selectedAmphureId = matchedAmphure.id;
              this.amphure_name = selectedAmphureName;
            } else {
              this.selectedAmphureId = null;
              this.amphure_name = '';
            }
          } else {
            this.filteredAmphures = [];
            this.selectedAmphureId = null;
            this.amphure_name = '';
          }
          if (this.selectedAmphureId != null) {
            const amphureId = this.selectedAmphureId;

            // กรองตำบลในอำเภอที่เลือก
            this.filteredTambons = this.tambons.filter(
              (a) => a.amphure_id === +amphureId
            );

            // ดึงชื่อจากที่อยู่
            const selectedTambonName = response.company_thambol;

            // หาใน list ว่าตรงกับตำบลไหน
            const matchedTambon = this.filteredTambons.find(
              (a) => a.name_th.trim() === selectedTambonName
            );

            if (matchedTambon) {
              this.selectedTambonId = matchedTambon.id;
              this.tambon_name = selectedTambonName;
              this.zipcode = response.company_postcode;
            } else {
              this.selectedTambonId = null;
              this.tambon_name = '';
              this.zipcode = '';
            }
          } else {
            this.filteredTambons = [];
            this.selectedTambonId = null;
            this.tambon_name = '';
          }
        }
      },
      error: (error) => {
        console.error('API error:', error);
        this.isLoading = false;
      },
    });
  }
}
